export const LANGUAGES = {
	HU: 'hu',
	EN: 'en'
};

export const ACTIVE_CAMPAIGN = {
	COMPANY_NAME: '2',
	GDPR: '7',
	GDPR_TRUE_VALUE: 'true',
	GDPR_FALSE_VALUE: 'false',
	CONTACT_JOBTITLE: '8',
	SOURCE_CAMPAIGN: '29',
	NEWSLETTER: '30',
	NEWSLETTER_TRUE_VALUE: 'Igen',
	NEWSLETTER_FALSE_VALUE: 'Nem'
}



// WEBPACK FOOTER //
// ../source/common/utils/constants.js